import React, { useRef } from 'react';
import styled from 'styled-components';

type FocusedContainerProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  role?: string;
};

const FocusedContainer = ({ children, className, onClick, role }: FocusedContainerProps) => {
  const divRef = useRef<HTMLDivElement>(null);

  const handleClick = e => {
    divRef.current?.focus();
    onClick && onClick(e);
  };

  return (
    <StyledContainer className={className} onClick={handleClick} tabIndex={-1} ref={divRef} role={role}>
      {children}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  &:focus {
    outline: none;
  }
`;

export default FocusedContainer;
